<p-tag *ngIf="value"
        styleClass="wrap"
        [value]="value() | valowValueToDisplay:field()"
        [severity]="getColor()">
</p-tag>